import React from 'react'
import centerpoints from '../data/oesterreich_centerpoints.js'
import fields from '../data/FieldDefinitions'
import Map from '../components/Map'
import { transform } from 'topojson-client'

const SYMBOL_SIZE = 2.4

function log(data) {
  console.log(data)
  return data
}

export default ({ field, data, symbols, ...props }) => {
  const getData = iso => {
    return (data.find(d => d.node.iso === iso) || {}).node
  }

  const getPathProperties = iso => {
    const d = getData(parseInt(iso))

    const children = <title>{`${d.name}`}</title>

    return {
      fill: 'white',
      onClick() {
        props.clickOnGemeinde && props.clickOnGemeinde(iso)
      },
      children,
    }
  }

  const overlayObjects = (d, i, projection) => {
    const r = 9
    const [cx, cy] = projection(centerpoints[d.properties.iso])

    const istBezirk = d.properties.iso.length === 3

    if (istBezirk) {
      if (d.properties.iso != 103 && d.properties.iso != 102)
        return (
          <text key={`c_${i}`} transform={`translate(${cx}, ${cy})`}>
            {d.properties.name}
          </text>
        )
      return
    }

    const scale = istBezirk ? 8 : 2

    const overlayData = istBezirk
      ? Object.entries(symbols).reduce((acc, [field, symbol]) => {
          acc[field] =
            data
              .filter(value => value.iso.startsWith(d.properties.iso))
              .findIndex(value => value[field] > 0) != -1
              ? 1
              : 0
          return acc
        }, {})
      : getData(parseInt(d.properties.iso))

    let x = 0,
      y = 0

    const overlaySymbols = Object.entries(
      symbols
    ).reduce((acc, [field, symbol], i) => {
      if (overlayData[field])
        acc.push(
          Array(overlayData[field])
            .fill()
            .map((x, i) => (
              <path
                d={symbol.d}
                fill={symbol.fill}
                transform={`translate(${acc.length * SYMBOL_SIZE}, ${i *
                  SYMBOL_SIZE})`}
              />
            ))
        )
      return acc
    }, [])

    const dx = (overlaySymbols.length - 1) * SYMBOL_SIZE / 2
    const dy =
      (overlaySymbols.reduce((acc, column) => Math.max(acc, column.length), 0) -
        1) *
      SYMBOL_SIZE /
      2

    return (
      cx &&
      overlaySymbols.length && (
        <g
          key={`c_${i}`}
          transform={`translate(${cx - dx * scale}, ${cy -
            dy * scale}) scale(${scale})`}
        >
          {overlaySymbols}
        </g>
      )
    )
  }

  return (
    <Map
      pathProperties={getPathProperties}
      overlayObjects={overlayObjects}
      className="symbolAtlas"
      {...props}
    />
  )
}



// WEBPACK FOOTER //
// ./src/container/SymbolAtlas.js